import React from 'react';
import { Box, Button, Typography, Divider, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

// ============================================
// Styled Components
// ============================================
const ModalContainer = styled('div')({
  backgroundColor: '#fff',
  borderRadius: '10px',
  width: '600px',
  minHeight: '350px',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});

const ModalHeader = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  color: '#fff',
  background: '#202020',
  height: '52px',
  borderRadius: '10px 10px 0 0',
  padding: '0px 20px',
});

const ModalTitle = styled(Typography)({
  fontSize: '16px',
});

const StyledCloseIcon = styled(CloseIcon)({
  cursor: 'pointer',
});

const ModalContent = styled(Box)({
  padding: '50px 100px 50px 40px',
});

const StyledDivider = styled(Divider)({
  color: '#e1e1e1',
});

const ButtonContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '50px',
  columnGap: '8px',
});

const CancelButton = styled(Button)({
  borderRadius: '10px',
  border: 'none',
  background: '#c5c5c5',
  color: '#fff',
  '&:hover': {
    border: 'none',
    background: '#c5c5c5',
  },
});

const SubmitButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'isSubmitting',
})(({ isSubmitting }) => ({
  borderRadius: '10px',
  opacity: isSubmitting ? 0.6 : 1,
  cursor: isSubmitting ? 'not-allowed' : 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: 8,
}));

const StyledCircularProgress = styled(CircularProgress)({
  color: 'white',
});

// ============================================
// Main Component
// ============================================
function UserModal(props) {
  const { t } = useTranslation();

  return (
    <ModalContainer>
      <ModalHeader>
        <ModalTitle className="title">{props.title}</ModalTitle>
        <StyledCloseIcon onClick={props.handleCloseModal} />
      </ModalHeader>

      <ModalContent>{props.children}</ModalContent>

      <StyledDivider />

      <ButtonContainer>
        <CancelButton variant="outlined" onClick={props.handleCloseModal}>
          {t('Cancel')}
        </CancelButton>
        <SubmitButton
          variant="contained"
          type="submit"
          onClick={props.handleSubmit}
          disabled={props.isSubmitting}
          isSubmitting={props.isSubmitting}>
          {props.isSubmitting ? <StyledCircularProgress size={16} /> : t('Save')}
        </SubmitButton>
      </ButtonContainer>
    </ModalContainer>
  );
}

export default UserModal;
